import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ApiResponse } from '../models/api-response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Pagination } from '../models/pagination';
import { User } from '../models/user';
import { List } from '../models/list';
import { Country } from '../models/country';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  currentUser: User;

  endpoint: string;

  constructor(
    private baseService: BaseService,
    private authSvc: AuthService
  ) {
    this.endpoint = 'users';
  }

  public getAll(pagination?: Pagination, nextId?: number): Observable<ApiResponse<List<User>>> {
    let roles = 'SUPPORT_EDITOR,SUPPORT_ADMIN,SUPER_USER';
    // let roles = null;
    return this.baseService.getAll<List<User>>(this.endpoint, { params: Object.assign({}, { roles: roles }, pagination, !!nextId ? { nextId: nextId } : {}) })
    .pipe(map(data => {
      data.payload.elements.forEach(e => {
        if (!e.id) {
          e.id = e._id;
          delete e._id;
        }
      });

      // FIXME: no pagination available
      // data.payload.pagination = Object.assign({}, pagination, { totalElements: data.payload.elements.length, totalPages: 1 });

      return data;
    }));
  }

  public findExistingUser(searchText: string) {
    return this.baseService.getAll<List<User>>(this.endpoint, { params: <{}>Object.assign({}, { searchText: searchText, elementsPerPage: 1000 })})
    .pipe(map(data => {
      data.payload.elements.forEach(e => {
        if (!e.id) {
          e.id = e._id;
          delete e._id;
        }
      });

      // FIXME: no pagination available
      // data.payload.pagination = Object.assign({}, pagination, { totalElements: data.payload.elements.length, totalPages: 1 });

      return data;
    }));
  }

  public getCurrentUser(): Observable<ApiResponse<User>> {
    // FIXME: pass a flag require auth and let BaseService + TokenInterceptor handle authorization headers
    // Force auth token for frontend requests
    let headers = new HttpHeaders().append('Authorization', `Bearer ${this.authSvc.getCurrentToken()}`);

      return this.baseService.get<User>(`${this.endpoint}/me`, headers).pipe(map(data => {
        this.currentUser = data.payload;
        return data;
      }));
  }

  public add(user: User): Observable<ApiResponse<User>> {
    return this.baseService.add<User>(this.endpoint, user);
  }

  public update(id: number, user: User): Observable<ApiResponse<User>> {
    // FIXME: pass a flag require auth and let BaseService + TokenInterceptor handle authorization headers
    // Force auth token for frontend requests
    let headers = new HttpHeaders().append('Authorization', `Bearer ${this.authSvc.getCurrentToken()}`);

    return this.baseService.update<User>(`${this.endpoint}/` + (!!id ? id : 'me'), user, headers)
    .pipe(map(data => {
      if (id === this.currentUser.id) {
        this.currentUser = data.payload;
      }
      return data;
    }));
  }

  public activate(id: number): Observable<ApiResponse<User>> {
    return this.baseService.add<User>(`${this.endpoint}/${id}/activate`)
    .pipe(map(data => {
      if (id === this.currentUser.id) {
        this.currentUser = data.payload;
      }
      return data;
    }));
  }

  public deactivate(id: number): Observable<ApiResponse<User>> {
    return this.baseService.add<User>(`${this.endpoint}/${id}/deactivate`)
    .pipe(map(data => {
      if (id === this.currentUser.id) {
        this.currentUser = data.payload;
      }
      return data;
    }));
  }

  public recover(email: string): Observable<ApiResponse<string>> {
    return this.baseService.add<string>(`${this.endpoint}/recover`, { email: email });
  }

  public addRole(userId: number, roleCode: string): Observable<ApiResponse<string>> {
    return this.baseService.add<string>(`${this.endpoint}/${userId}/roles`, { code: roleCode });
  }

  public deleteRole(userId: number, roleCode: string): Observable<ApiResponse<string>> {
    return this.baseService.delete<string>(`${this.endpoint}/${userId}/roles/${roleCode}`);
  }

  public getCountries(): Observable<ApiResponse<List<Country>>> {
    // FIXME: pass a flag require auth and let BaseService + TokenInterceptor handle authorization headers
    // Force auth token for frontend requests
    let headers = new HttpHeaders().append('Authorization', `Bearer ${this.authSvc.getCurrentToken()}`);

    return this.baseService.get<List<Country>>(`${this.endpoint}/countries`, headers)
    .pipe(map(data => {
      // FIXME: countries are placed inside records property instead of elements
      let payload = <any>data.payload;
      payload.elements = payload.records;
      delete payload.records;
      return data;
    }));
  }

  public getUserInfo() {
    return this.currentUser;
  }

}
